import {
  Email as EmailIcon,
  LocationOn,
  CheckCircle,
  Search,
  FormatListBulleted,
} from "@mui/icons-material";

export const initialData = [
  {
    id: String.prototype.generateUUID(),
    visible: false,
    name: "whereIsMyMoney",
    icon: <Search color="primary" />,
    group: "menu",
    href: "/where-money",
  },
  {
    id: String.prototype.generateUUID(),
    visible: false,
    name: "ibanVerification",
    icon: <CheckCircle color="primary" />,
    group: "menu",
    href: "/iban-verification",
  },
  {
    id: String.prototype.generateUUID(),
    visible: false,
    name: "bulkReceipt",
    icon: <FormatListBulleted color="primary" />,
    href: "/accounts",
    group: "menu",
  },
  {
    id: String.prototype.generateUUID(),
    visible: true,
    name: "contactUs",
    icon: <EmailIcon color="primary" />,
    href: "/contactus",
    group: "contact",
  },
  {
    id: String.prototype.generateUUID(),
    visible: true,
    name: "nearestBranches",
    icon: <LocationOn color="primary" />,
    href: "https://www.upt.com.tr/tr/hizmet-noktalari.html",
    group: "contact",
    isExternal: true,
  },
];
